module.exports = __webpack_public_path__ + "img/webauthn.f18418d0.png";